import React, { useEffect, useState } from "react";
import { Row, Col, CardBody, Table } from "reactstrap";
import { formatDateForDisplay } from "../Utils/UtilityFunctions";
import CommonButton from "../Utils/CommonButton";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUserByName } from "../../slices/UserManagement/GetUserByName/thunk";

const OperatorDetails = ({ setLoading, operatorData }) => {
  const {
    tradingName,
    existsDuring,
    domain,
    state,
    city,
    country,
    postcode,
    street1,
    street2,
    status,
    partyCharacteristic = [],
    adminDetails,
    operatorId,
  } = operatorData || {};
  const navigate = useNavigate();
  const profile = useSelector((state) => state.ViewDocument.documentView);
  const [data, setData] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUserByName(adminDetails?.userName, setLoading, {}, setData));
  },[adminDetails])
  
  const renderDoubleColumnRow = (
    leftLabel,
    leftValue,
    rightLabel,
    rightValue,
    noBorder = false
  ) => {
    const formatValue = (label, value) => {
      if (!label) return "";
      return value ? value : "-";
    };

    return (
      <div className={`mb-3 pb-2 ${noBorder ? "" : "border-bottom"}`}>
        <Row>
          <Col lg={6} md={6} sm={12}>
            {leftLabel && <label className="fw-semibold">{leftLabel}</label>}
            <p className="detail-value mb-0">
              {formatValue(leftLabel, leftValue)}
            </p>
          </Col>
          <Col lg={6} md={6} sm={12}>
            {rightLabel && <label className="fw-semibold">{rightLabel}</label>}
            <p className="detail-value mb-0">
              {formatValue(rightLabel, rightValue)}
            </p>
          </Col>
        </Row>
      </div>
    );
  };

  return (
    <div className="customer-profile-container py-2">
      <Row className="justify-content-center">
        <Col lg={10}>
          <div className=" px-3 py-3 my-2">
            <CardBody>
              <div className="d-flex align-items-center mb-4">
                <div
                  className="profile-image-container border me-4"
                  style={{
                    width: "115px",
                    height: "115px",
                    backgroundColor: profile?.filePath ? "#fff" : "#D9D9D9",
                  }}
                >
                  {profile?.filePath ? (
                    <img
                      src={profile?.filePath}
                      alt="profile"
                      style={{
                        width: "115px",
                        height: "115px",
                        objectFit: "cover",
                      }}
                    />
                  ) : null}
                </div>
                <div>
                  <h4 className="mb-1 fw-bold text-black">
                    {tradingName || ""}
                  </h4>
                </div>

                <div className="ms-auto mt-n5">
                  <CommonButton
                    color={"main-color"}
                    className={
                      "btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap mt-n4"
                    }
                    icon={
                      <i className="ri-edit-box-line label-icon align-middle fs-16 me-1"></i>
                    }
                    btnTxtClsName={"px-2 ps-1 ms-3 me-1"}
                    type={"submit"}
                    buttonAction={() => {
                      navigate(`/edit-operator/${operatorId}`);
                    }}
                    buttonText={"Edit"}
                  />
                </div>
              </div>
              <div className="profile-details-section text-break">
                <p className="fs-5 fw-semibold mb-3 pb-2 border-bottom">
                  Business Details
                </p>
                {/* {renderDoubleColumnRow("Business Name", tradingName, "", "")} */}
                {((data?.rbac !== "Native" || data?.rbac !== "Zitadel")) ? renderDoubleColumnRow("Business Name", tradingName, "redirect URI", `${window.env.REACT_APP_KEYCLOAK_ENV}/realms/${window.env.REACT_APP_KEYCLOAK_REALM}/broker/${operatorId}/endpoint`) : renderDoubleColumnRow("Business Name", tradingName, "", "")}
                {renderDoubleColumnRow(
                  "Domain",
                  domain,
                  "End Date",
                  formatDateForDisplay(existsDuring?.endDateTime)
                )}
                {renderDoubleColumnRow(
                  "Address",
                  street1,
                  "Address 2",
                  street2
                )}
                {renderDoubleColumnRow("Country", country, "State", state)}
                {renderDoubleColumnRow("City", city, "Zipcode", postcode, true)}
                <p className="fs-5 fw-semibold mb-3 pb-2 border-bottom">
                  Admin Details
                </p>
                {renderDoubleColumnRow(
                  "First Name",
                  adminDetails?.profile?.firstName,
                  "Last Name",
                  adminDetails?.profile?.lastName
                )}
                {renderDoubleColumnRow(
                  "Email",
                  adminDetails?.email,
                  "Phone Number",
                  `${adminDetails?.dialCode} ${adminDetails?.phone}`
                )}
                {renderDoubleColumnRow(
                  "User Name",
                  adminDetails?.userName,
                  "Zipcode",
                  postcode,
                  true
                )}
              </div>
            </CardBody>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default OperatorDetails;
